module.exports = __webpack_public_path__ + "media/images/prizes/prize-img-ec9ecfa0d96530f7e703d3f605e2aef3.png";